import { useContext, useEffect, useState } from 'react';
import { getUrlPreview } from '../../apis/tms/utils.api';
import { getUrlInContent } from '../../common/checkUrl';
import { CreatePostValueContext } from '../../components/modal/training-module/post/provider/CreatePostValueProvider';
import useDebounce from '../useDebounce';

export const useGetLinkThumbnail = () => {
  const { postInfo } = useContext(CreatePostValueContext);
  return useGenericGetLinkThumbnail(postInfo.content);
};

export const useGenericGetLinkThumbnail = (content: string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [firstUrl, setFirstUrl] = useState<string>('');
  const [thumbnailInfo, setThumbnailInfo] = useState<{
    title: string;
    description: string;
    thumbnailUrl: string;
    domain: string;
  }>({
    title: '',
    description: '',
    thumbnailUrl: '',
    domain: '',
  });
  const debounced = useDebounce({ value: content, delay: 500 });
  const getPreviewThumbnail = async (url: string) => {
    setLoading(true);
    try {
      const res: any = await getUrlPreview(url);
      let domain: URL | string = new URL(url);
      domain = domain.hostname;
      domain = (domain as string).replace('www.', '');
      setThumbnailInfo({ ...res, domain });
      setFirstUrl(url);
    } catch (error: any) {
      setThumbnailInfo({
        title: '',
        description: '',
        thumbnailUrl: '',
        domain: '',
      });
      setFirstUrl('');
    }
    setLoading(false);
  };

  const updateThumbnail = (url: string) => {
    getPreviewThumbnail(url);
  };

  useEffect(() => {
    const listUrlInContent = getUrlInContent(content as string);
    if (
      listUrlInContent &&
      firstUrl !== listUrlInContent[0] &&
      listUrlInContent.length > 0
    ) {
      updateThumbnail(listUrlInContent[0]);
    } else if (!listUrlInContent && thumbnailInfo.thumbnailUrl) {
      setThumbnailInfo({
        title: '',
        description: '',
        thumbnailUrl: '',
        domain: '',
      });
      setFirstUrl('');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return {
    thumbnailInfo,
    urls: getUrlInContent(content as string),
    loading,
  };
};
